module.exports = __webpack_public_path__ + "img/wujinmu7.15865928.jpg";